export const RetailerReportQuery = `
query retailerReportQuery(
    $fromDate: DateTime,
    $toDate: DateTime,
    $retailerId: ID,
    $town: String,
    $area: ID,
    $state: ID,
    $after: String,
    $userId: ID
  ){
    allCallHistorys(
      retailer_Id: $retailerId,
      town: $town,
      workHistory_Area: $area,
      workHistory_Work_State: $state,
      callStart_Gte: $fromDate,
      callStart_Lte: $toDate,
      first: 20,
      after: $after,
      workHistory_Work_Caller: $userId
    ){
      pageInfo{
        endCursor
        hasNextPage
      }
      edges{
        node{
          id
          retailer{
            firm
          }
          callDate
          callStart
          duration
          mobileNumber
          callStatus
          duration
          workHistory{
            work{
              caller{
                id
                employee{
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const RetailerQnAQuery = `
  query reportQnAQuery(
    $callHistoryId: ID
  )
    {
    allCallResponses(
      call: $callHistoryId
    ){
      edges{
        node{
          id
          answers
          question
          isAlert
          remarks
          call{
            duration
            retailer{
              firm
            }
          }
          workHistory{
            work{
              caller{
                employee{
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;
